module.exports = __webpack_public_path__ + "static/img/login-logo.d2dced0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/score/login-logo.png
// module id = 379
// module chunks = 0